<script lang="ts">
	import type { Device } from 'src/types/Device';
	import SidepanelMainViewHost from 'src/components/Sidepanel/SidepanelMainViewHost.svelte';

	export let device: Device;
</script>

<SidepanelMainViewHost {device} />
